(function () {
  'use strict';
  // Aucun pays n'est affiché (décision du 09.10) : « Acheteur vérifié · date · coloris » pour tous.
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  var stars = function (n) { var h = ''; for (var i = 1; i <= 5; i++) h += '<i' + (i <= n ? '' : ' class="off"') + '>★</i>'; return '<span class="mavp-st" aria-label="' + n + ' étoiles sur 5">' + h + '</span>'; };
  var fmtAvg = function (x) { return String(Math.round(x * 10) / 10).replace('.', ','); };
  var nf = function (n) { return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ' '); };

  var zoom;
  function openZoom(src, cap) {
    if (!zoom) {
      zoom = document.createElement('figure');
      zoom.className = 'mavp-zoom';
      zoom.innerHTML = '<img alt="Photo envoyée par un client"><figcaption></figcaption>';
      zoom.addEventListener('click', function () { zoom.classList.remove('is-on'); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') zoom.classList.remove('is-on'); });
      document.body.appendChild(zoom);
    }
    zoom.querySelector('img').src = src;
    zoom.querySelector('figcaption').textContent = cap || '';
    zoom.classList.add('is-on');
  }

  function init(sec) {
    var src = sec.getAttribute('data-src');
    if (!src) return;
    fetch(src, { credentials: 'omit' }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (all) { var d = all && all[sec.getAttribute('data-key')]; if (!d || !d.r || !d.r.length) return renderEmpty(sec); render(sec, d); })
      .catch(function () { renderEmpty(sec); });
  }

  // Pas d'avis exploitable pour ce produit : la section reste masquée et on réaffiche
  // le mur d'avis général du gabarit (clé dans data-fallback, masqué par défaut via CSS).
  function renderEmpty(sec) {
    var key = sec.getAttribute('data-fallback');
    if (!key) return;
    document.querySelectorAll('[id$="__' + key + '"]').forEach(function (w) {
      w.classList.add('mavp-fallback-on');
      // Entrée B′ : « Soyez le premier » sous le mur, même tiroir-formulaire.
      var dr = document.querySelector('[data-mavp-drawer]');
      var wrap = w.querySelector('.mav-wrap') || w;
      if (dr && !wrap.querySelector('.mavp-first')) {
        var f = document.createElement('div');
        f.className = 'mavp-first';
        f.innerHTML = '<span class="mavp-first__medal" aria-hidden="true"><svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M20.2 3.8a5.6 5.6 0 0 0-7.9 0L5 11.1V19h7.9l7.3-7.3a5.6 5.6 0 0 0 0-7.9z"/><path d="M16 8 2 22"/><path d="M17.5 15H9"/></svg></span><div><h3>' + esc(dr.getAttribute('data-first-title')) + '</h3><p>' + esc(dr.getAttribute('data-first-text')) + '</p></div><button class="mavp__cta" type="button" data-mavp-open>' + esc(dr.getAttribute('data-cta')) + '</button>';
        wrap.appendChild(f);
      }
    });
  }

  // Tiroir « Donner mon avis » (commun aux entrées C et B′). Mode « demo » : rien n'est envoyé ;
  // mode « contact » : formulaire de contact natif Shopify, la page revient avec form.posted_successfully.
  var PICK = ['', 'Décevante', 'Moyenne', 'Correcte', 'Très bien', 'Excellente'];
  function initDrawer() {
    var dr = document.querySelector('[data-mavp-drawer]');
    if (!dr || dr.getAttribute('data-mavp-ready')) return;
    dr.setAttribute('data-mavp-ready', '1');
    var form = dr.querySelector('form.mavp-form'), fields = dr.querySelector('[data-mavp-fields]'), done = dr.querySelector('[data-mavp-done]');
    var note = dr.querySelector('[data-mavp-note]'), pickl = dr.querySelector('[data-mavp-pickl]'), stars = Array.prototype.slice.call(dr.querySelectorAll('[data-mavp-star]'));
    var opener = null;
    function variantTitle() {
      try {
        var map = JSON.parse(dr.getAttribute('data-variants') || '{}');
        var id = new URL(location.href).searchParams.get('variant') || (document.querySelector('form[action*="/cart/add"] [name="id"]') || {}).value;
        return (id && map[id]) || dr.getAttribute('data-variant') || '';
      } catch (e) { return dr.getAttribute('data-variant') || ''; }
    }
    function open(btn) {
      opener = btn || null;
      var v = variantTitle();
      var c = dr.querySelector('[data-mavp-coloris]'), ct = dr.querySelector('[data-mavp-coloris-txt]');
      if (c) c.value = v; if (ct) ct.textContent = v || '-';
      dr.hidden = false; document.body.classList.add('mavp-noscroll');
      var first = dr.querySelector('[data-mavp-star="5"]'); if (first && !fields.hidden) first.focus();
      try { if (window.dataLayer) window.dataLayer.push({ event: 'product_review_form_open', source: btn && btn.closest('.mavp-first') ? 'wall' : 'band' }); } catch (e) { }
    }
    function close() { dr.hidden = true; document.body.classList.remove('mavp-noscroll'); if (opener) opener.focus(); }
    function setNote(n) {
      note.value = n || '';
      stars.forEach(function (s) { s.classList.toggle('on', +s.getAttribute('data-mavp-star') <= n); s.setAttribute('aria-checked', String(+s.getAttribute('data-mavp-star') === n)); });
      pickl.textContent = n ? n + ' : ' + PICK[n] : 'Choisissez une note';
    }
    stars.forEach(function (s) {
      s.setAttribute('role', 'radio'); s.setAttribute('aria-checked', 'false');
      s.addEventListener('click', function () { setNote(+s.getAttribute('data-mavp-star')); });
      s.addEventListener('mouseenter', function () { var n = +s.getAttribute('data-mavp-star'); stars.forEach(function (x) { x.classList.toggle('hov', +x.getAttribute('data-mavp-star') <= n); }); });
      s.addEventListener('mouseleave', function () { stars.forEach(function (x) { x.classList.remove('hov'); }); });
    });
    document.addEventListener('click', function (e) {
      var o = e.target.closest('[data-mavp-open]'); if (o) { e.preventDefault(); open(o); return; }
      if (e.target.closest('[data-mavp-close]') && dr.contains(e.target)) { e.preventDefault(); close(); }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !dr.hidden) close(); });
    function showDone(name) {
      fields.hidden = true; done.hidden = false;
      var dn = dr.querySelector('[data-mavp-done-name]'); if (dn) dn.textContent = name ? ', ' + name : '';
    }
    form.addEventListener('submit', function (e) {
      if (!note.value) { e.preventDefault(); pickl.textContent = 'Choisissez une note pour continuer'; stars[4].focus(); return; }
      var name = (dr.querySelector('#mavp-f-name') || {}).value || '';
      try { if (window.dataLayer) window.dataLayer.push({ event: 'product_review_form_submit', rating: +note.value, mode: dr.getAttribute('data-mode') }); } catch (err) { }
      if (dr.getAttribute('data-mode') === 'demo') { e.preventDefault(); showDone(name.trim()); return; }
      // mode « contact » : envoi natif. Ne jamais court-circuiter l'événement submit : le script anti-spam de
      // Shopify l'intercepte pour joindre le jeton reCAPTCHA (sinon « Missing CAPTCHA token »), puis renvoie
      // le formulaire lui-même ; la page revient ensuite avec [data-mavp-posted].
      if (!form.checkValidity()) return;
      var btn = form.querySelector('[data-mavp-submit]'); if (btn) { btn.textContent = 'Envoi…'; btn.setAttribute('aria-busy', 'true'); }
    });
    // Retour après envoi : marqueur Liquid (form.posted_successfully?) ou, en secours, ?contact_posted=true dans l'URL
    var posted = dr.querySelector('[data-mavp-posted]') || /[?&]contact_posted=true/.test(location.search);
    if (posted && dr.getAttribute('data-mode') === 'contact') { showDone(''); open(null); }
  }

  function render(sec, d) {
    var rows = sec.querySelector('[data-mavp-rows]');
    var INITIAL = parseInt(sec.getAttribute('data-initial'), 10) || 6;
    var STEP = parseInt(sec.getAttribute('data-step'), 10) || 6;
    var every = d.r.slice();
    // Tous les avis affichés entrent dans la liste (photo seule comprise) : en-tête, filtre « Tous »,
    // zone chaude et passerelle donnent ainsi le même total (demande Mathieu 11.10).
    var all = every.filter(function (r) { return r.t || (r.p && r.p.length); });
    var nPhoto = all.filter(function (r) { return r.p && r.p.length; }).length;
    var dist = d.dist || {};
    var total = d.total || all.length;

    sec.querySelector('[data-mavp-avg]').textContent = fmtAvg(d.avg || 5);
    sec.querySelector('[data-mavp-avgstars]').outerHTML = stars(Math.round(d.avg || 5));
    var nPhotoTotal = d.nphoto || nPhoto;
    sec.querySelector('[data-mavp-count]').textContent = nf(total) + ' avis' + (nPhotoTotal ? ' · ' + nf(nPhotoTotal) + ' photo' + (nPhotoTotal > 1 ? 's' : '') : '');
    var sub = sec.querySelector('[data-mavp-sub]');
    sub.textContent = fmtAvg(d.avg || 5) + '/5 sur ' + nf(total) + ' avis · ' + (nPhotoTotal ? 'photos et textes' : 'textes') + ' envoyés par les acheteurs';

    var bars = sec.querySelector('[data-mavp-bars]');
    var html = '';
    for (var s = 5; s >= 1; s--) {
      var n = dist[s] || 0, pct = total ? Math.round(n / total * 100) : 0;
      html += '<li><button type="button" data-star="' + s + '" aria-label="Voir les avis ' + s + ' étoiles"><span>' + s + ' ★</span><i><b style="width:' + pct + '%"></b></i><em>' + pct + ' %</em></button></li>';
    }
    bars.innerHTML = html;

    var state = { filter: 'all', shown: INITIAL };
    var chips = sec.querySelector('[data-mavp-chips]');
    var defs = [['all', 'Tous (' + all.length + ')'], ['photo', 'Avec photos (' + nPhoto + ')'], ['5', '5 ★'], ['4', '4 ★'], ['3-', '3 ★ et moins']].filter(function (c) { return c[0] !== 'photo' || nPhoto > 0; });
    chips.innerHTML = defs.map(function (c) { return '<button type="button" class="mavp__chip" data-filter="' + c[0] + '" aria-pressed="' + (c[0] === 'all') + '">' + c[1] + '</button>'; }).join('');

    function match(r) {
      if (state.filter === 'all') return true;
      if (state.filter === 'photo') return r.p && r.p.length;
      if (state.filter === '3-') return r.s <= 3;
      return String(r.s) === state.filter;
    }
    function setFilter(f) {
      state.filter = f; state.shown = INITIAL;
      chips.querySelectorAll('.mavp__chip').forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-filter') === f)); });
      draw();
    }
    chips.addEventListener('click', function (e) { var b = e.target.closest('[data-filter]'); if (b) setFilter(b.getAttribute('data-filter')); });
    bars.addEventListener('click', function (e) { var b = e.target.closest('[data-star]'); if (!b) return; var s = b.getAttribute('data-star'); setFilter(s === '3' || s === '2' || s === '1' ? '3-' : s); });

    var more = sec.querySelector('[data-mavp-more]');
    more.addEventListener('click', function () { state.shown += STEP; draw(); });

    function rowHTML(r) {
      var thumb = r.p && r.p.length
        ? '<button class="mavp__thumb" type="button" data-zoom="' + esc(r.p[0]) + '" data-cap="' + esc(r.t) + '"><img src="' + esc(r.p[0]) + '" alt="" loading="lazy" width="64" height="64">' + (r.p.length > 1 ? '<i>+' + (r.p.length - 1) + '</i>' : '') + '</button>'
        : '<span class="mavp__thumb mavp__thumb--none" aria-hidden="true">A</span>';
      var meta = ['Acheteur vérifié', r.v ? 'Coloris ' + r.v : ''].filter(Boolean).join(' · ');
      var txt = r.t ? '<p class="mavp__txt">' + esc(r.t) + '</p>' : '<p class="mavp__txt mavp__txt--photo">Photo envoyée par l’acheteur</p>';
      return '<li class="mavp__row">' + thumb + '<div><div class="mavp__l1">' + stars(r.s) + '<time datetime="' + esc(r.d) + '">' + esc(r.dl) + '</time></div>' + txt + '<p class="mavp__meta">' + esc(meta) + '</p></div></li>';
    }
    function draw() {
      var list = all.filter(match);
      var vis = list.slice(0, state.shown);
      rows.innerHTML = vis.length ? vis.map(rowHTML).join('') : '<li class="mavp__empty">Aucun avis dans cette catégorie pour le moment.</li>';
      var left = list.length - vis.length;
      more.hidden = left <= 0;
      more.textContent = 'Afficher plus d’avis (' + vis.length + ' sur ' + list.length + ')';
    }
    draw();

    var rail = sec.querySelector('[data-mavp-rail]');
    if (rail) {
      var pics = [];
      every.forEach(function (r) { (r.p || []).forEach(function (u, k) { if (k === 0) pics.push({ u: u, r: r }); }); });
      if (pics.length < 3) { sec.querySelector('[data-mavp-railwrap]').hidden = true; }
      else {
        rail.innerHTML = pics.slice(0, 16).map(function (x) {
          var r = x.r;
          var cap = r.t || ('Photo envoyée' + (r.v ? ' · coloris ' + r.v : ''));
          return '<article class="mavp__pol"><button type="button" data-zoom="' + esc(x.u) + '" data-cap="' + esc(cap) + '"><img src="' + esc(x.u) + '" alt="" loading="lazy"></button><div class="mavp__polcap">' + stars(r.s) + '<p>' + esc(cap) + '</p><p class="mavp__polmeta">' + esc('Acheteur vérifié · ' + r.dl) + '</p></div></article>';
        }).join('');
        var prev = sec.querySelector('[data-mavp-prev]'), next = sec.querySelector('[data-mavp-next]');
        if (prev) prev.addEventListener('click', function () { rail.scrollBy({ left: -460, behavior: 'smooth' }); });
        if (next) next.addEventListener('click', function () { rail.scrollBy({ left: 460, behavior: 'smooth' }); });
      }
    }

    sec.addEventListener('click', function (e) { var b = e.target.closest('[data-zoom]'); if (b) openZoom(b.getAttribute('data-zoom'), b.getAttribute('data-cap')); });
    if (sec.getAttribute('data-bridge') === 'true') bridge(sec, every, all, nPhotoTotal, d.avg || 5);
    sec.hidden = false;
    try { if (window.dataLayer) window.dataLayer.push({ event: 'product_reviews_view', reviews_total: total, reviews_loaded: all.length }); } catch (e) { }
  }

  // Passerelle zone chaude → section (pistes 1 + 2, décision du 09.10) : la ligne de note de la buy-box
  // et le lien « lire tous les avis » prennent le chiffre propre au modèle et pointent vers la section ;
  // sous le triptyque, une bande de polaroids (5 premières photos) + « +N photos ↓ » + lien de lecture.
  function bridge(sec, every, all, nPhoto, avg) {
    var hot = document.querySelector('.mbb.mbb-rv[data-mbb-rv]');
    var line = document.querySelector('a.mbb-avis__link[data-mbb-avis-link]');
    var allLink = document.querySelector('a.mbb-rv__all[data-mbb-rv-all]');
    var href = '#' + sec.id;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function go(e) {
      e.preventDefault();
      sec.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      // Les images chargées en route décalent la cible : on recale une fois le défilement fini.
      setTimeout(function () { if (Math.abs(sec.getBoundingClientRect().top - 90) > 40) sec.scrollIntoView({ behavior: 'auto', block: 'start' }); }, reduce ? 150 : 900);
      try { history.replaceState(null, '', href); } catch (err) { }
    }
    // Même total que l'en-tête de la section (tous les avis affichés, photo seule comprise)
    var nAvis = every.length;
    var label = fmtAvg(avg) + '/5 · ' + nf(nAvis) + ' avis sur ce modèle';
    // 10.10 (demande Mathieu) : la ligne sous le titre garde la note globale de la boutique (4,7/5 · 1223 avis) ;
    // seul le lien « lire les N avis » de la zone chaude prend le chiffre du modèle.
    void line; void label;
    if (allLink) { allLink.textContent = fmtAvg(avg) + '/5 · lire les ' + nf(nAvis) + ' avis ↓'; allLink.setAttribute('href', href); allLink.addEventListener('click', go); }
    // 12.10 (Mathieu) : univers sans témoignage ciblé (montres enfant…) → la zone chaude reprend 3 avis RÉELS du modèle.
    if (hot && hot.hasAttribute('data-mbb-rv-auto') && !hot.getAttribute('data-filled')) {
      var grid = hot.querySelector('[data-mbb-rv-grid]');
      var pick = every.filter(function (r) { return r.s >= 4 && r.t && r.t.length >= 25 && r.t.length <= 260; })
        .sort(function (a, b) { return (b.s - a.s) || ((b.p && b.p.length ? 1 : 0) - (a.p && a.p.length ? 1 : 0)) || (b.t.length - a.t.length); }).slice(0, 3);
      if (grid && pick.length) {
        grid.innerHTML = pick.map(function (r, k) {
          var st = ''; for (var j = 1; j <= 5; j++) st += '<span' + (j > r.s ? ' class="mbb-rv__st--off"' : '') + '>★</span>';
          return '<article class="mbb-rv__c mbb-rv__c--v2"><div class="mbb-rv__top"><span class="mbb-rv__av mbb-rv__av--' + (k % 3) + '" aria-hidden="true">A</span><b class="mbb-rv__nm">Acheteur vérifié</b><span class="mbb-rv__st" aria-label="' + r.s + ' étoiles sur 5">' + st + '</span></div>'
            + '<p class="mbb-rv__x">' + esc(r.t) + '</p>'
            + '<div class="mbb-rv__meta"><span class="mbb-rv__tag">' + (r.v ? 'Coloris ' + esc(r.v) : 'Avis du modèle') + '</span><span>' + esc(r.dl || '') + '</span></div></article>';
        }).join('');
      } else if (grid) { grid.remove(); }
      if (pick.length || every.some(function (r) { return r.p && r.p.length; })) { hot.style.display = ''; hot.setAttribute('data-filled', '1'); }
    }
    if (!hot || hot.querySelector('.mavp-bridge')) return;
    // Variante A (09.10) : filet à losange + planche de carrés droits, dernière case « +N ».
    var pics = [];
    every.forEach(function (r) { if (r.p && r.p.length && pics.length < 6) pics.push({ u: r.p[0], cap: r.t || ('Photo envoyée' + (r.v ? ' · coloris ' + r.v : '')) }); });
    var wrap = document.createElement('div');
    wrap.className = 'mavp-bridge';
    var html = '';
    if (pics.length >= 3) {
      html += '<div class="mavp-bridge__rule" aria-hidden="true"><i></i><span>Au poignet · ' + nf(nPhoto) + ' photo' + (nPhoto > 1 ? 's' : '') + ' d’acheteurs</span><i></i></div>';
      html += '<div class="mavp-bridge__strip" aria-label="Photos envoyées par les acheteurs">' + pics.map(function (x, i) {
        return '<button type="button" class="mavp-bridge__sq" data-zoom="' + esc(x.u) + '" data-cap="' + esc(x.cap) + '" aria-label="Agrandir la photo ' + (i + 1) + '"><img src="' + esc(x.u) + '" alt="" loading="lazy" width="76" height="76"></button>';
      }).join('') + (nPhoto > pics.length ? '<a class="mavp-bridge__plus" href="' + href + '"><b>+' + nf(nPhoto - pics.length) + '</b><small>voir tout</small></a>' : '') + '</div>';
    }
    html += '<p class="mavp-bridge__more"><a href="' + href + '">Lire les ' + nf(nAvis) + ' avis ↓</a><small>' + (nPhoto ? 'Avis et photos publiés par des acheteurs' : 'Avis publiés par des acheteurs') + '</small></p>';
    wrap.innerHTML = html;
    hot.appendChild(wrap);
    wrap.addEventListener('click', function (e) {
      var z = e.target.closest('[data-zoom]'); if (z) { openZoom(z.getAttribute('data-zoom'), z.getAttribute('data-cap')); return; }
      var a = e.target.closest('a[href="' + href + '"]'); if (a) go(e);
    });
    try { if (window.dataLayer) window.dataLayer.push({ event: 'product_reviews_bridge_view', photos: pics.length }); } catch (e) { }
  }

  function boot() { initDrawer(); document.querySelectorAll('[data-mavp]:not([data-mavp-ready])').forEach(function (s) { s.setAttribute('data-mavp-ready', '1'); init(s); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
